import React from 'react';
import PropTypes from 'prop-types';
import { Button, CopyButton, DotsVertical, Edit01, Gift01, Menu, Table, Trash01 } from '@opendate-app/setlist';

const HoldsTable = ({ holds, onEdit, onDelete }) => {
  const columns = [
    { key: 'name', header: 'Name', primary: true },
    {
      key: 'release_at',
      header: 'Release Date',
      render: hold => (hold.release_at ? new Date(hold.release_at).toLocaleString() : '')
    },
    { key: 'inventory_held_count', header: 'Inventory Held' },
    {
      key: 'area_places',
      header: 'GA Places',
      render: hold => Object.entries(hold.area_places || {})
        .filter(([, places]) => Number(places) > 0)
        .map(([label, places]) => `${label}: ${places} ${Number(places) === 1 ? 'place' : 'places'}`)
        .join(', ')
    },
    {
      key: 'public_channels_url',
      header: 'Private Link',
      render: hold => (hold.public_channels_url ? (
        <div className="d-flex align-items-center" style={{ gap: 8 }}>
          <a href={hold.public_channels_url} target="_blank" className="text-truncate" style={{ maxWidth: '360px' }}>
            {hold.public_channels_url}
          </a>
          <CopyButton value={hold.public_channels_url} label={null} aria-label="Copy link" variant="tertiary" size="sm" />
        </div>
      ) : '')
    },
    {
      key: 'actions',
      header: '',
      align: 'right',
      render: hold => (
        <Menu
          placement="bottom-end"
          trigger={<Button variant="tertiary" size="sm" icon={DotsVertical} aria-label="Actions" />}
          items={[
            { icon: Edit01, label: 'Manage hold', onClick: () => onEdit(hold) },
            {
              icon: Gift01,
              label: 'Comp Tickets',
              onClick: () => {
                if (hold.comp_tickets_url) { window.location.href = hold.comp_tickets_url; }
              }
            },
            { icon: Trash01, label: 'Release hold', destructive: true, onClick: () => onDelete(hold) }
          ]}
        />
      )
    }
  ];

  return (
    <div className="mb-3">
      <Table columns={columns} data={holds} getRowKey={hold => hold.id} empty="No holds yet." />
    </div>
  );
};

HoldsTable.propTypes = {
  holds: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default HoldsTable;
